import { render, staticRenderFns } from "./create-tool.vue?vue&type=template&id=51872055&scoped=true&"
import script from "./create-tool.ts?vue&type=script&lang=ts&"
export * from "./create-tool.ts?vue&type=script&lang=ts&"
import style0 from "./create-tool.scss?vue&type=style&index=0&id=51872055&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51872055",
  null
  
)

export default component.exports